// extracted by mini-css-extract-plugin
export default {"wrapper":"Section2_wrapper__-QN62","wrapperInner":"Section2_wrapperInner__TILsA"};